"use client";

import { create } from "zustand";

interface ServiceReviewModalStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useServiceReviewModal = create<ServiceReviewModalStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
